<era-master-detail flexGrowLeft="2"
                   flexGrowRight="3">
  <era-master>
    <era-panel>
      <era-title>
        <span title
              i18n>Permissions</span>
        <era-context-menu>
          <button ngbDropdownItem
                  [routerLink]="['../']">Back</button>
        </era-context-menu>
      </era-title>
      <era-group-permissions-entity-list></era-group-permissions-entity-list>
    </era-panel>
  </era-master>
</era-master-detail>